<template>
    <section class="breadcrumbs-custom">
        <div class="parallax-container">
            <div class="material-parallax parallax"><img src="/assets/images/custom_cakes_1.png" alt="breadcrumbs" ></div>
            <div class="breadcrumbs-custom-body parallax-content context-dark">
                <div class="container">
                    <h2 class="breadcrumbs-custom-title">Contact Us</h2>
                </div>
            </div>
        </div>
        <div class="breadcrumbs-custom-footer">
            <div class="container">
                <ul class="breadcrumbs-custom-path">
                    <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
                    <li class="active">Contact Us</li>
                </ul>
            </div>
        </div>
    </section>

    <section class="section section-sm section-first bg-gray-4">
        <div class="container">
            <div class="row row-xl row-30 justify-content-center">
                <div class="col-sm-6 col-lg-4">
                    <article class="pricing-classic">
                        <div class="pricing-classic-header"><img class="pricing-classic-figure" src="/assets/images/truganina.jpg" alt="" width="346" height="229"/>
                            <div class="pricing-classic-caption">
                                <div>
                                    <h3 class="pricing-classic-title">CakeGurus Truganina</h3>
                                    <div class="pricing-classic-price-wrap">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pricing-classic-body">
                            <ul class="pricing-classic-list">
                                <li>Shop 16, 211 Leakes Rd, Truganina VIC 3029</li>
                                <li><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></li>
                                <li><a href="tel:0423644818">0423 644 818</a>, <a href="tel:0393941681">03 9394 1681</a></li>
                                <li>7 days (10am - 9pm)</li>
                            </ul>
                        </div>
                    </article>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <article class="pricing-classic pricing-classic-sale">
                        <div class="pricing-classic-header"><img class="pricing-classic-figure" src="/assets/images/melbourne.jpg" alt="" width="346" height="229"/>
                            <div class="pricing-classic-caption">
                                <div>
                                    <h3 class="pricing-classic-title">CakeGurus Cranbourne</h3>
                                </div>
                            </div>
                        </div>
                        <div class="pricing-classic-body">
                            <ul class="pricing-classic-list">
                                <li>14 Lurline Street, Cranbourne VIC 3977</li>
                                <li><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></li>
                                <li><a href="tel:0412401771">0412 401 771</a>, <a href="tel:0359953490">03 5995 3490</a></li>
                                <li>7 days (11am - 8pm)</li>
                            </ul>
                        </div>
                    </article>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <article class="pricing-classic pricing-classic-sale">
                        <div class="pricing-classic-header"><img class="pricing-classic-figure" src="/assets/images/epping.jpg" alt="" width="346" height="229"/>
                            <div class="pricing-classic-caption">
                                <div>
                                    <h3 class="pricing-classic-title">CakeGurus Epping</h3>
                                </div>
                            </div>
                        </div>
                        <div class="pricing-classic-body">
                            <ul class="pricing-classic-list">
                                <li>Shop 3, 145 Gateway boulevard, Epping, VIC - 3076</li>
                                <li><a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a></li>
                                <li><a href="tel:0412401771">0416 300 460</a></li>
                                <li>6 days (11am - 8pm) (Monday Closed)</li>
                            </ul>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-default text-md-start">
        <div class="container">
            <div class="row row-50 justify-content-center">                
                <div class="col-lg-8 pe-lg-5">
                    <div class="title-classic mb-4">
                        <h3 class="title-classic-title">Get in touch</h3>
                        <p class="title-classic-subtitle text-muted">We are available 24/7 by fax, e-mail or by phone. You can also use our <br class="d-none d-lg-block">quick contact form to ask a question about our products.</p>
                    </div>
                    <form class="mt-4" method="post" @submit.prevent="normalInquery">
                        <div class="row row-20 row-md-30">
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.name" type="text" class="form-input" id="contact-name-2" required />
                                    <label class="form-label" for="contact-name-2">Name</label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.email" type="email" class="form-input" id="contact-email-2" required />
                                    <label class="form-label" for="contact-email-2">E-mail</label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.phone" type="text" class="form-input" id="contact-phone-2" required />
                                    <label class="form-label" for="contact-phone-2">Phone</label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.subject" type="text" class="form-input" id="contact-subject-2" required />
                                    <label class="form-label" for="contact-subject-2">Subject</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-wrap">
                                    <label class="form-label" for="contact-message-2">Message</label>
                                    <textarea v-model="form.message" rows="4" class="form-input textarea-lg" id="contact-message-2"></textarea>
                                </div>
                            </div>
                        </div>
                        <button type="submit" :disabled="loading" class="button button-lg button-secondary button-zakaria mt-4">
                            {{ loading ? "Sending..." : "Send Message" }}
                        </button>
                        <!-- Error message -->
                        <div v-if="error" class="mt-4 text-danger">{{ error }}</div>
                        <!-- Success message -->
                        <div v-if="success" class="mt-4 text-success">{{ success }}</div>
                    </form>
                </div>
                <div class="col-lg-4 mt-5 mt-lg-0">
                    <div class="contact-box bg-gray-4 p-4 p-xl-5 rounded-3 h-100 d-flex flex-column justify-content-center">
                        <div class="mb-4">
                            <h4 class="font-weight-bold text-uppercase" style="color: #c14679;">Business Inquiry</h4>
                            <p class="text-muted mt-3">Interested in partnering with us? We're always looking for exciting business opportunities and collaborations.</p>
                        </div>
                        <ul class="list-unstyled mb-5">
                            <li class="d-flex align-items-center mb-3">
                                <span class="icon mdi mdi-email-outline fs-3 me-3" style="color: #c14679;"></span>
                                <a href="mailto:info@cakegurus.com.au" class="text-dark fw-bold">info@cakegurus.com.au</a>
                            </li>
                        </ul>
                        <button class="button button-secondary button-zakaria w-100" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                            Open Inquiry Form
                        </button>
                    </div>
                </div>
            </div>
        
        </div>
    </section>

    <section class="section">
        <!-- Native Google Map -->
        <div id="map" style="width: 100%; height: 500px;"></div>
    </section>

    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Business Enquiry</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form class="row gy-2 gx-3 align-items-center" @submit.prevent="submitInquiryForm">
                        <div class="col-12">
                            <label class="visually-hidden" for="autoSizingInput">Name</label>
                            <input type="text" name="name" class="form-control" id="autoSizingInput" placeholder="Name" required v-model="inquiryForm.name">
                        </div>
                        <div class="col-6">
                            <label class="visually-hidden" for="autoSizingInputGroup">Phone</label>
                            <input type="text" name="phone" class="form-control" id="autoSizingInputGroup" placeholder="Phone" required v-model="inquiryForm.phone">
                        </div>
                        <div class="col-6">
                            <label class="visually-hidden" for="autoSizingInputGroup">Email</label>
                            <input type="text" name="email" class="form-control" id="autoSizingInputGroup" placeholder="Email" required v-model="inquiryForm.email">
                        </div>
                        <div class="col-12">
                            <label class="visually-hidden" for="autoSizingInputGroup">Inquiry</label>
                            <textarea name="message" class="form-control" id="autoSizingInputGroup" placeholder="Inquiry" required v-model="inquiryForm.message"></textarea>
                        </div>
                        <div class="col-auto">
                            <!-- <button type="submit" class="btn btn-primary" :disabled="inquiryLoading">Submit</button> -->
                            <button
                                type="submit"
                                :disabled="inquiryLoading"
                                class="button button-sm button-secondary button-zakaria"
                            >
                                {{ inquiryLoading ? "Sending..." : "Send Message" }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { api } from '@/plugins/axios';
import { useCommonStore } from "@/stores/commonStore";

const commonStore = useCommonStore();

// ✅ Initial form values
const initialForm = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: ""
};

// Reactive form (copy of initialForm)
const form = ref({ ...initialForm });
const loading = ref(false);
const error = ref(null);
const success = ref(null);

// Business Inquiry Modal
const inquiryInitialForm = {
  name: "",
  email: "",
  phone: "",
  message: ""
};
const inquiryForm = ref({ ...inquiryInitialForm });
const inquiryLoading = ref(false);
const inquiryError = ref(null);


const normalInquery =async () => {
  loading.value = true;
  error.value = null;
  success.value = null;

  try {
    const res = await api.post(`send-inquiry`, form.value);

    success.value = res.data.message;

    // Reset form
    form.value = { ...initialForm };
  } catch (err) {
    if (err.response) {
      error.value = err.response.data.message || "Registration failed.";
    } else {
      error.value = "Something went wrong.";
    }
  } finally {
    loading.value = false;
  }
};

// Submit business inquiry form from modal
const submitInquiryForm = async () => {
    inquiryLoading.value = true;
    inquiryError.value = null;

    try {
        const res = await api.post(`send-business-inquiry`, inquiryForm.value);
        alert(res.data.message);

        // Reset form
        inquiryForm.value = { ...inquiryInitialForm };

        document.querySelector('#staticBackdrop .btn-close').click();
    } catch (err) {
        if (err.response) {
            inquiryError.value = err.response.data.message || "Submission failed.";
        } else {
            inquiryError.value = "Something went wrong. Please try again.";
        }
        alert(inquiryError.value)
    } finally {
        inquiryLoading.value = false;
    }
};

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Contact CakeGurus',
    },
  ],
})

onMounted(async () => {
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)      

    commonStore.loaderVisible = false;

    // Google Maps Custom Initialization
    window.initContactMap = () => {
        const mapElement = document.getElementById('map');
        if (!mapElement) return;

        const map = new window.google.maps.Map(mapElement, {
            zoom: 9,
            center: new window.google.maps.LatLng(-37.8136, 144.9631),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        });

        const infowindow = new window.google.maps.InfoWindow();
        let marker, i;

        const locations = [
            ['<div style="text-align:center"><h5>CakeGurus Cranbourne</h5> <br> <span>14 Lurline Street, Cranbourne VIC 3977 <br> Email : info@cakegurus.com.au <br> Phone: 0412 401 771, 03 5995 3490 <br> Time: 7 days (11am - 8pm)</span></div>', -38.111490, 145.275100, 3],
            ['<div style="text-align:center"><h5>CakeGurus Truganina</h5> <br> <span>Shop 16, 211 Leakes Rd, Truganina VIC 3029 <br> Email : info@cakegurus.com.au <br> Phone: 0423 644 818, 03 9394 1681 <br> Time: 7 days (10am - 9pm)</span></div>', -37.839820, 144.748170, 2],
            ['<div style="text-align:center"><h5>CakeGurus Epping</h5> <br> <span>3/145 Gateway blvd, Epping <br> Email : info@cakegurus.com.au <br> Phone: 0416 300 460 <br> Time: 6 days (11am - 7pm) (Monday Closed)</span></div>', -37.635725, 144.999241, 1],
        ];

        for (i = 0; i < locations.length; i++) {
            marker = new window.google.maps.Marker({
                position: new window.google.maps.LatLng(locations[i][1], locations[i][2]),
                map: map,
                icon: '/assets/images/gmap_marker.png'
            });

            window.google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent(locations[i][0]);
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }
    };

    if (window.google && window.google.maps) {
        window.initContactMap();
    } else {
        const mapScriptId = 'google-maps-script';
        if (!document.getElementById(mapScriptId)) {
            const script = document.createElement('script');
            script.id = mapScriptId;
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&callback=initContactMap';
            document.head.appendChild(script);
        }
    }
})
</script>

<style scoped>
.material-parallax img { 
  position: relative;
  filter: brightness(0.5);
}
</style>